import PropTypes from 'prop-types';
import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    marginTop: 10,
    marginBottom: 20,
  },
}));


const TextFieldComponent = ({
  id, label,
  input: { name, value, onChange },
  meta: { touched, error, warning },
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl} error={!!(touched && error)}>
      {label && <InputLabel htmlFor={id}>{label}</InputLabel>}

      <Input
        id={id}
        label={label}
        onChange={onChange}
        value={value}
        fullWidth
        {...restProps}
      />

      {(touched && error) && <FormHelperText id={`${name}-error`}>{error}</FormHelperText>}
    </FormControl>
  );
};

TextFieldComponent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default TextFieldComponent;
